import { ReactElement } from 'react';

type RefreshButtonProps = {
  refreshing?: boolean;
  onRefresh: () => void;
};

/**
 * React component for refresh button.
 * @param props - Properties of Refresh button component.
 * @returns React component.
 */
export default function RefreshButton(props: RefreshButtonProps): ReactElement {
  const { refreshing, onRefresh } = props;
  return (
    <button
      disabled={refreshing}
      type="button"
      onClick={onRefresh}
      className={`material-icons-outlined text-gray-500 dark:text-gray-300 text-xl leading-5 cursor-pointer ${
        refreshing && 'cursor-progress'
      } ${refreshing && 'animate-spin'}`}
    >
      refresh
    </button>
  );
}
